<template>
  <vSelect 
    ref="formSelectUser"
    v-model="selectedObject"
    label="fullName"
    :placeholder="placeholder"
    :options="options"
    :reduce="reduce"
    :disabled="disabled"
    :readonly="readonly"
    :required="required"
    @search="searchTerm = $event"
  >
    <template v-slot:no-options="{ search, searching }">
      <template v-if="searching && search.length >= 3">
        No results found for <em>{{ search }}</em
        >.
      </template>
      <em v-else style="opacity: 0.5">Start typing to search for a user - 3 character minimum.</em>
    </template>
  </vSelect>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
export default {
  props: {
    placeholder: {
      type: String,
      default: () => 'Select a User'
    },
    required: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    selected: {
      default: () => null
    },
    roles: {
      default: () => 'member'
    },
    newUser: {
      default: () => false
    },
    reduce: null
  },
  data () {
    return {
      loaded: false,
      selectedObject: null,
      searchTerm: null,
      options: []
    }
  },
  computed: {
    ...mapGetters([
      'userList'
    ])
  },
  methods: {
    ...mapActions([
      'getUser',
      'getUsers',
      'resetUsers'
    ]),
    async getMissingUser () {
      let userResource = this.selectedObject.split('/')
      let user = await this.getUser({
        id: userResource[userResource.length-1]
      })
      return user
    },
    async doGetUsers () {
      //if (!this.userList.length) {
        await this.getUsers({
          roles: 'role_' + this.roles,
          businesses: this.currentBusiness.id,
          pagination: false,
          fullName: this.searchTerm
        })
      // }

      let options = [ ...this.userList ]
      // add new user option
      if (this.newUser) {
        let newUser = this.newUser
        if (typeof newUser !== 'object') {
          newUser = { id: newUser, '@id': newUser, fullName: 'New User' }
        }
        options.push(newUser)
      }
      this.options = options

      
    },
    setSelectedObject (val) {
      if (!this.loaded && this.selectedObject === val) return
      this.selectedObject = val
    }
  },
  watch: {
    selected (val) {
      this.setSelectedObject(val)

      // does selected exist in list
      let selectedExists = this.options.find(obj => obj['@id'] === val)
      if (val && typeof selectedExists === 'undefined') {
        // get member and add to list
        this.getMissingUser().then(user => {
          this.options.push(user)
        })
      }
    },
    searchTerm(val) {
      if (val === null) return
      if (val === '' && this.selectedObject === null) {
        this.options = []
        return
      }
      if (val.length < 3) return
      this.doGetUsers()
    },

    selectedObject (val) {
      this.$emit('input', val)
    }
  },
  async mounted () {
    // await this.doGetUsers()
    this.loaded = true
    this.setSelectedObject(this.selected)
  },
  destroyed () {
    this.resetUsers()
  },
  components: { vSelect }
}
</script>